export default __webpack_public_path__ + "static/ring-57e92ce52a8c4b2326300c9210debd46.png";